module.exports = __webpack_public_path__ + "img/refresh.f4f104ce.svg";